import axios from 'axios'
import{
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL
} from '../types'
import {server_base_url} from '../../shared'

export const logInUser = (login_id, auth0_access_token) => async (dispatch) =>{
    try {
        dispatch({
            type:LOGIN_REQUEST,
        })

        const url = `${server_base_url}/auth0login`

        const config = {
            headers:{
                'Content-Type':'application/json',
                "X-AuthorityToken": "auth-wpf-desktop"
            }
        }

        let {data} = await axios.post(
            url,
            {login_id, auth0_access_token},
            config
        )

        dispatch({
            type:LOGIN_SUCCESS,
            payload:data
        })

        data.auth0_access_token = auth0_access_token
        localStorage.setItem('userInfo', JSON.stringify(data))


    } catch (error) {
        dispatch({
            type:LOGIN_FAIL,
            payload:
                error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })
    }
}


export const logOutUser = () => async (dispatch) =>{

    let userinfo = JSON.parse(localStorage.getItem('userInfo'))

    //remove access token
    try {
        dispatch({
            type:LOGOUT_REQUEST,
        })
        const auth0_access_token = userinfo.auth0_access_token
        const auth0_user_id = userinfo.auth0_user_id
        const url = `${server_base_url}/auth0logout`
        const config = {
            headers:{
                'Content-Type':'application/json',
                "X-AuthorityToken": "auth-wpf-desktop",
                "X-AccessToken" : auth0_access_token
            }
        }

        let {data} = await axios.post(
            url,
            {auth0_user_id: auth0_user_id, auth0_access_token: auth0_access_token},
            config
        )

        dispatch({
            type:LOGOUT_SUCCESS,
            payload:data
        })

        // localStorage.removeItem('userInfo')

    } catch (error) {
      // localStorage.removeItem('userInfo')

        dispatch({
            type:LOGOUT_FAIL,
            payload:
                error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })
    }
}
